import React from 'react';

export const DownloadIcon = () => {
    return (
        <svg
            width="24"
            height="21"
            viewBox="0 0 24 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.71538 1.25977V8.29872H4.84961L11.9905 15.3815L19.1511 8.29872H14.4583V1.25977H9.71538Z"
                stroke="#DA291C"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.4705 13.749H22C22.5523 13.749 23 14.1967 23 14.749V18.7486C23 19.3009 22.5523 19.7486 22 19.7486H2C1.44772 19.7486 1 19.3009 1 18.7486V14.749C1 14.1967 1.44772 13.749 2 13.749H7.36862"
                stroke="#DA291C"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle cx="17.7715" cy="17.4673" r="1" fill="#DA291C" />
            <circle cx="20.7715" cy="17.4673" r="1" fill="#DA291C" />
        </svg>
    );
};

